export const student = [
  { title: "Обучающемуся", type: "title" },
  {
    type: "list",
    title: "Эссе",
    icon: "doc-text-icon",
    links: [
          {
           type: "link",
           title: "Отправка эссе",
           icon: "circle-icon",
           name: "student",
           },
           {
           type: "link",
           title: "Эссе команды",
           icon: "circle-icon",
           name: "team",
           },
    ],
  },
{
    type: "list",
    title: "Расписание",
    icon: "calendar",
    links: [
          {
           type: "link",
           title: "Расписание",
           icon: "circle-icon",
           name: "schedule",
           },
    ],
  },
{
    type: "list",
    title: "Вопросы",
    icon: "list-icon",
    links: [
          {
           type: "link",
           title: "Вопрос Эксперту",
           icon: "circle-icon",
           name: "qa-student",
           },
    ],
  },

];
